import template from "templates/course_map/dashboard_card.hbs";
import { View, getOption } from "backbone.marionette";

export default class DashboardCard extends View.extend({
  tagName: "li",
  template,

  events: {
    "click [data-card]": "onCardClick",
  },
}) {
  initialize(options) {
    this.options = options || {};
    this.collections = getOption(this, "collections");
    this.courseId = getOption(this, "courseId");
    this.isCreatorMode = getOption(this, "isCreatorMode");

    this.project = this.model.get("project");
    this.creator = this.model.get("creator");
    this.creatorType = this.model.get("creatorType");

    // Resolve this card's submission (may be absent until the lazy page fetch
    // lands) and re-render just this card when it changes, e.g. a publish
    // toggle, rather than re-rendering the whole grid.
    this.submission = this._findSubmission();
    if (this.submission) {
      this.listenTo(this.submission, "change", this.render);
    }
  }

  onCardClick(event) {
    event.preventDefault();
    // Clicking the Published switch toggles publish inline rather than
    // navigating, matching the old matrix cell's behavior.
    if (event.target.closest('[data-behavior="publish-toggle"]')) {
      return this._togglePublish();
    }
    return this._navigateToSubmission();
  }

  _togglePublish() {
    const submission = this.submission || this._findSubmission();
    if (!submission) return;
    if (submission.get("current_user_percentage")) {
      return submission.toggleEvaluationPublish();
    }
    return this._navigateToSubmission();
  }

  _navigateToSubmission() {
    const segment = `${this.creatorType.toLowerCase()}s`;
    const url = `courses/${this.courseId}/${segment}/evaluations/creator/${this.creator.id}/project/${this.project.id}`;
    return window.Vocat.router.navigate(url, true);
  }

  _findSubmission() {
    return this.collections.submission.findWhere({
      creator_type: this.creatorType,
      creator_id: this.creator.id,
      project_id: this.project.id,
    });
  }

  serializeData() {
    const submission = this.submission;
    let evaluation;
    if (submission) {
      evaluation = {
        is_loaded: true,
        has_asset: submission.get("has_asset"),
        can_be_evaluated: this.project.evaluatable(),
        current_user_published: submission.get("current_user_published"),
        current_user_percentage: submission.get("current_user_percentage"),
        instructor_score_percentage: submission.get(
          "instructor_score_percentage",
        ),
        user_left_feedback: submission.get("user_left_feedback"),
        comments_count: submission.get("comments_count"),
        cid: submission.cid,
      };
    } else {
      evaluation = { is_loaded: false };
    }
    return {
      isProjectContext: this.isCreatorMode,
      courseId: this.courseId,
      creatorSegment: `${this.creatorType.toLowerCase()}s`,
      projectId: this.project.id,
      creatorId: this.creator.id,
      project: {
        id: this.project.id,
        name: this.project.get("name"),
        due_date: this.project.get("due_date"),
      },
      creator: {
        id: this.creator.id,
        name: this.creator.get("name"),
        gravatar: this.creator.get("gravatar"),
      },
      evaluation,
    };
  }
}
